import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
import Icon from '@mdi/react';
import {
  mdiClose,
  mdiFilterOutline,
  mdiFilterRemoveOutline,
  mdiMagnify,
} from '@mdi/js';

import RefinancingUpload from '../RefinancingUpload';

const CaseListToolbar = ({
  search,
  onSubmitSearch,
  onChangeSearch,
  cleanFilters,
  onClickFilterCase,
  emptySearch,
  showCaseActions,
  hideReassignButton,
  onClickReasingCase,
  showRefinancingUpload,
  history,
  location,
  onClickModalAssignCase,
  dateError,
  startDate,
  endDate,
  handleStartDate,
  handleEndDate,
  validateToday,
  handleExport,
}) => (
  <Card style={{ paddingBottom: '10px' }}>
    <CardBody className="card_body_flex" style={{ padding: '5px 10px' }}>
      <Col md="8" className="crm-col-container">
        <form className="crm-form-container" onSubmit={onSubmitSearch}>
          <div className="crm-search-input-container">
            <Icon path={mdiMagnify} size={1} />
            <input
              onChange={onChangeSearch}
              value={search}
              placeholder="Nombre o RUT cliente"
            />
            <button
              type="button"
              onClick={cleanFilters}
              disabled={!search}
            >
              <Icon path={mdiClose} />
            </button>
          </div>
          <button
            type="button"
            className="crm-actions-btn"
            onClick={onClickFilterCase}
          >
            <Icon path={mdiFilterOutline} />
          </button>
          <button
            type="button"
            className="crm-actions-btn"
            onClick={cleanFilters}
            hidden={emptySearch}
          >
            <Icon path={mdiFilterRemoveOutline} />
          </button>
        </form>
      </Col>

      {showCaseActions && (
        <Col md="4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div className="crm-case-banner-container">
            <button
              type="button"
              hidden={hideReassignButton}
              onClick={onClickReasingCase}
              className="crm-white-btn"
            >
              Reasignar
            </button>
            {showRefinancingUpload && (
              <RefinancingUpload history={history} location={location} />
            )}
            <button
              type="button"
              className="crm-black-btn"
              onClick={onClickModalAssignCase}
            >
              + Nuevo Caso
            </button>
          </div>
        </Col>
      )}

      <Col style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <Col
          xs="auto"
          sm="auto"
          md="auto"
          style={{ marginBottom: dateError ? '0px' : '20px', paddingLeft: '0px', paddingRight: '0px' }}
        >
          <Label className="export-label">Desde</Label>
          <DatePicker
            className="export-picker"
            maxDate={new Date()}
            selected={startDate}
            onChange={handleStartDate}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            locale="es"
            dateFormat="P"
          />
          {dateError && <p className="export-error">{dateError}</p>}
        </Col>
        <Col xs="auto" sm="auto" md="auto" style={{ marginBottom: '20px', paddingLeft: '0px', paddingRight: '0px' }}>
          <Label className="export-label">Hasta</Label>
          <DatePicker
            className="export-picker"
            selected={endDate}
            onChange={handleEndDate}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            maxDate={new Date()}
            locale="es"
            dateFormat="P"
          />
        </Col>
        <Col xs="auto" sm="auto" md="auto" style={{ paddingLeft: '0px' }}>
          <button
            type="button"
            style={{ margin: '6px 0px' }}
            className={validateToday() ? 'asignar2 new_contact_button export-btn-disabled' : 'asignar2 new_contact_button'}
            onClick={handleExport}
          >
            Exportar
          </button>
        </Col>
      </Col>
    </CardBody>
  </Card>
);

CaseListToolbar.propTypes = {
  search: PropTypes.string,
  onSubmitSearch: PropTypes.func.isRequired,
  onChangeSearch: PropTypes.func.isRequired,
  cleanFilters: PropTypes.func.isRequired,
  onClickFilterCase: PropTypes.func.isRequired,
  emptySearch: PropTypes.bool.isRequired,
  showCaseActions: PropTypes.bool.isRequired,
  hideReassignButton: PropTypes.bool.isRequired,
  onClickReasingCase: PropTypes.func.isRequired,
  showRefinancingUpload: PropTypes.bool.isRequired,
  history: PropTypes.object,
  location: PropTypes.object,
  onClickModalAssignCase: PropTypes.func.isRequired,
  dateError: PropTypes.string,
  startDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.object]),
  endDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.object]),
  handleStartDate: PropTypes.func.isRequired,
  handleEndDate: PropTypes.func.isRequired,
  validateToday: PropTypes.func.isRequired,
  handleExport: PropTypes.func.isRequired
};

CaseListToolbar.defaultProps = {
  search: '',
  history: null,
  location: null,
  dateError: undefined,
  startDate: null,
  endDate: null
};

export default CaseListToolbar;
